import { client } from "../prismic/PrismicApp";
import { getApiErrorMessage } from "../../helpers/api";

/**
 * Action types
 * @property {string}
 */
export const types = {
  BLOG_CATEGORIES_ERROR: "BLOG_CATEGORIES_ERROR",
  BLOG_CATEGORIES_LOADING: "BLOG_CATEGORIES_LOADING",
  BLOG_CATEGORIES_SUCCESS: "BLOG_CATEGORIES_SUCCESS",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  /**
   * Updates blog categories state
   * @param {array} state
   * @param {object} action
   * @param {string} action.type
   * @param {array} action.blogCategories
   * @memberof Reducers
   */
  blogCategories: (state = [], action) => {
    switch (action.type) {
      case types.BLOG_CATEGORIES_SUCCESS:
        return action.blogCategories;
      default:
        return state;
    }
  },

  /**
   * Updates blog categories error state
   * @param {string} state
   * @param {object} action
   * @param {string} action.type
   * @param {string} action.message
   * @memberof Reducers
   */
  blogCategoriesError: (state = null, action) => {
    switch (action.type) {
      case types.BLOG_CATEGORIES_ERROR:
        return action.message;
      case types.BLOG_CATEGORIES_LOADING:
      case types.BLOG_CATEGORIES_SUCCESS:
        return null;
      default:
        return state;
    }
  },

  /**
   * Updates blog categories loading state
   * @param {boolean} state
   * @param {object} action
   * @param {string} action.type
   * @memberof Reducers
   */
  blogCategoriesLoading: (state = false, action) => {
    switch (action.type) {
      case types.BLOG_CATEGORIES_ERROR:
      case types.BLOG_CATEGORIES_SUCCESS:
        return false;
      case types.BLOG_CATEGORIES_LOADING:
        return true;
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  /**
   * Fetch blog categories from Prismic API
   * @memberof Actions
   */
  fetchBlogCategories: () => dispatch => {
    dispatch(actions.handleBlogCategoriesLoading());

    client
      .getAllByType("blog_category", {
        orderings: [{ field: "my.blog_category.order" }],
        pageSize: 100, // max allowed
      })
      .then(response => {
        if (!!response && Array.isArray(response)) {
          dispatch(actions.handleBlogCategoriesSuccess(response));
        } else {
          dispatch(
            actions.handlBlogCategoriesError(getApiErrorMessage(response))
          );
        }
      })
      .catch(error => {
        dispatch(actions.handlBlogCategoriesError(getApiErrorMessage(error)));
      });
  },

  /**
   * Handle blog categories error messages
   * @param {string} message
   * @memberof Actions
   */
  handlBlogCategoriesError: message => ({
    type: types.BLOG_CATEGORIES_ERROR,
    message: message,
  }),

  /**
   * Handle blog categories loading events
   * @memberof Actions
   */
  handleBlogCategoriesLoading: () => ({
    type: types.BLOG_CATEGORIES_LOADING,
  }),

  /**
   * Handle blog categories success
   * @param {array} results
   * @memberof Actions
   */
  handleBlogCategoriesSuccess: blogCategories => ({
    type: types.BLOG_CATEGORIES_SUCCESS,
    blogCategories: blogCategories,
  }),
};
